export default __webpack_public_path__ + "static/home-page-image-3762bba0b65e769a33bde13f4bc97003dd76edc7812a77fda54a89ad0ba25777.png";